import script from "./DueBar.vue?vue&type=script&setup=true&lang=js"
export * from "./DueBar.vue?vue&type=script&setup=true&lang=js"

import "./DueBar.vue?vue&type=style&index=0&id=a432bcfa&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a432bcfa"]])

export default __exports__